/****************************************************
 * Module Name:  stoneTypeProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class StoneTypeProxy {

    static GetAllStoneType = (callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/stonetype",
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetAllStoneTypeByDisabled = (disabled, callback) => {
        let params = { disabled: disabled };
        restAPICall(
            Constants.MANAGER_URL + "/stonetype",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


    static GetSingleStoneType = (stoneTypeName, callback) => {

        restAPICall(
            Constants.MANAGER_URL + `/stonetype/${stoneTypeName}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static CheckStoneTypeAvailable = (stoneType, callback) => {

        restAPICall(
            Constants.MANAGER_URL + `/stonetype/available/${stoneType}`,
            "get",
            Constants.userToken,
            undefined,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static AddStoneType = (stoneType, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/stonetype",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(stoneType),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static UpdateStoneType = (stoneType, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/stonetype",
            "put",
            Constants.userToken,
            undefined,
            JSON.stringify(stoneType),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static DeleteStoneType = (stoneType, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/stonetype",
            "delete",
            Constants.userToken,
            undefined,
            JSON.stringify(stoneType),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}
